import React, { useState, useRef } from "react"

const EmailTemplate = ({ title, text }) => {
  let [showCopySuccessMessage, setShowCopySuccessMessage] = useState(false)

  const templateRef = useRef(null)

  const copyEmailTemplate = () => {
    const templateToCopy = templateRef.current.innerText
      .replace(/\n\s*\n\s*\n/g, "\n\n")
      .trim()

    navigator.clipboard.writeText(templateToCopy)

    if (!showCopySuccessMessage) {
      setShowCopySuccessMessage(true)

      setTimeout(() => {
        setShowCopySuccessMessage(false)
      }, 2000)
    }
  }

  return (
    <div className="email-template-container mt-10 mb-4">
      <h3>{title}</h3>

      <div className="email-template">
        <div className="email-template__text" ref={templateRef}>
          <p dangerouslySetInnerHTML={{ __html: text }} />
        </div>

        <div className="email-template__copy-button-container">
          <span
            className={`email-template__copy-button-alert ${
              showCopySuccessMessage
                ? "email-template__copy-button-alert--visible"
                : ""
            }`}
            aria-live="polite"
          >
            Email template copied!
          </span>

          <button
            type="button"
            className="email-template__copy-button"
            aria-label="Copy email template to clipboard"
            onClick={copyEmailTemplate}
          >
            <img
              height="30"
              alt=""
              role="presentation"
              src="/icons/copy-to-clipboard.svg"
            />
          </button>
        </div>
      </div>
    </div>
  )
}

export default EmailTemplate
